import { useEffect, useState } from "react";
import { words } from "../data/words";
import WordCard from "../components/WordCard";
import { getContributions, getWordsByIds } from "../utils/api";
import { getContributorId, getSeenWords } from "../utils/storage";

const topHints = (hints) =>
  [...hints].sort((a, b) => b.weight - a.weight).slice(0, 3);

const groupHintsByWord = (hints) =>
  hints.reduce((groups, hint) => {
    return {
      ...groups,
      [hint.word]: [...(groups[hint.word] || []), hint]
    };
  }, {});

const fallbackSeenWords = (seenWords) =>
  seenWords
    .map(seen => words.find(wordItem => wordItem.word === seen))
    .filter(Boolean);

export default function Profile() {
  const [tab, setTab] = useState("guesses");
  const [seenWordCards, setSeenWordCards] = useState([]);
  const [userHints, setUserHints] = useState([]);
  const [status, setStatus] = useState("");

  useEffect(() => {
    loadProfile();
  }, []);

  async function loadProfile() {
    const seenWords = getSeenWords();
    const numericSeenIds = seenWords.filter(id => Number.isInteger(id));

    try {
      const [seenWordsFromApi, contributions] = await Promise.all([
        getWordsByIds(numericSeenIds),
        getContributions(getContributorId())
      ]);

      setSeenWordCards(seenWordsFromApi);
      setUserHints(contributions);
      setStatus("");
    } catch {
      setSeenWordCards(fallbackSeenWords(seenWords));
      setUserHints([]);
      setStatus("Profile data will sync after the database API is reachable.");
    }
  }

  const hintsByWord = groupHintsByWord(userHints);
  const contributedWords = Object.keys(hintsByWord);

  return (
    <div className="card">
      <div className="tabs">
        <div
          className={tab === "guesses" ? "tab active" : "tab"}
          onClick={() => setTab("guesses")}
        >
          Guesses
        </div>

        <div
          className={tab === "hints" ? "tab active" : "tab"}
          onClick={() => setTab("hints")}
        >
          Hints
        </div>
      </div>

      <div className="profile-list">
        {tab === "guesses" &&
          seenWordCards.map(wordItem => (
            <WordCard
              key={wordItem.id || wordItem.word}
              word={wordItem.word}
              hints={topHints(wordItem.hints)}
              preview="Top hints"
            />
          ))}

        {tab === "guesses" && seenWordCards.length === 0 && (
          <div className="empty-state">No words seen yet.</div>
        )}

        {tab === "hints" &&
          contributedWords.map(word => (
            <WordCard
              key={word}
              word={word}
              hints={hintsByWord[word]}
              preview={`${hintsByWord[word].length} contribution${
                hintsByWord[word].length === 1 ? "" : "s"
              }`}
            />
          ))}

        {tab === "hints" && contributedWords.length === 0 && (
          <div className="empty-state">No hints submitted yet.</div>
        )}
      </div>

      {status && <div className="status-text">{status}</div>}
    </div>
  );
}
